import NhomDucBMT from './NhomDucBMT'

export default NhomDucBMT
